import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/useAuth";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const returnPath = `${location.pathname}${location.search}${location.hash}`;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: returnPath }} />;
  }

  // Force profile completion if phone is missing
  // But allow access to the completion page itself
  if (!user.phone && location.pathname !== "/complete-profile") {
    return <Navigate to="/complete-profile" replace />;
  }

  return children;
};

export default ProtectedRoute;
